module.exports = __webpack_public_path__ + "img/icon-marker.ea80e493.png";